import { useEffect, useState } from "react";
import { WifiOff, X } from "lucide-react";

// PATCH 37 Mi16 — a dismissible "you're offline" banner, so dropped connectivity is never silent.
export default function OfflineBanner() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && navigator.onLine === false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    const down = () => { setOffline(true); setDismissed(false); };
    const up = () => setOffline(false);
    window.addEventListener("offline", down);
    window.addEventListener("online", up);
    return () => { window.removeEventListener("offline", down); window.removeEventListener("online", up); };
  }, []);
  if (!offline || dismissed) return null;
  return (
    <div data-testid="offline-banner" role="status"
      style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 100, background: "var(--control)",
        borderBottom: "1px solid var(--border-strong)", padding: "8px 16px", display: "flex", alignItems: "center", gap: 10 }}>
      <WifiOff size={14} aria-hidden="true" />
      <span className="k-heading" style={{ fontSize: 13, fontWeight: 600 }}>You're offline</span>
      <span className="k-muted" style={{ fontSize: 12 }}>Changes may not save until your connection returns.</span>
      <button className="k-link" data-testid="offline-dismiss" aria-label="Dismiss" style={{ marginLeft: "auto", lineHeight: 0 }}
        onClick={() => setDismissed(true)}><X size={14} /></button>
    </div>
  );
}
